import { monolithApiUrl } from '../config/app';
import { endpoints } from '../constants/routing';
import {
  IClaimLinkTemplatesPage,
  IClaimLinkTemplatesPageRequest,
  IFetchClaimLinkTemplatesResponse,
} from '../types/templates';
import { QueryRequest } from '../utils/request';

export const TemplatesService = {
  getClaimLinkTemplates: (params: IClaimLinkTemplatesPageRequest, token?: string): Promise<IClaimLinkTemplatesPage> =>
    QueryRequest<IFetchClaimLinkTemplatesResponse>(
      {
        endpoint: `${monolithApiUrl}${endpoints.getClaimLinkTemplates}`,
        method: 'POST',
        body: JSON.stringify(params),
      },
      token,
    ).then((res) => {
      if (res.ok) {
        return {
          templates: res.body.claim_page_experiences ?? [],
          total_count: res.body.total_count ?? 0,
        };
      }
      throw res;
    }),
};
